"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutationRemoveBasketOutcomeById = exports.mutationComputeBasketOutcomesMap = void 0;
exports.mutationChangeOrdinars = mutationChangeOrdinars;
exports.mutationClearDeletedOrdinarsInfo = mutationClearDeletedOrdinarsInfo;
const isEqual_1 = __importDefault(require("../../../utils/functions/isEqual"));
const omit_1 = __importDefault(require("../../../utils/functions/omit"));
const _1 = require(".");
/*
 Utility function to correct update ordinar state if we got more or less outcomes
*/
function mutationChangeOrdinars(ordinarState, newOutcomeIds, deletedOutcomeIds) {
    if (deletedOutcomeIds.length) {
        mutationClearDeletedOrdinarsInfo(ordinarState, deletedOutcomeIds);
    }
    newOutcomeIds.forEach((outcomeId) => {
        ordinarState.outcomesAmounts[outcomeId] = '';
    });
}
/*
 Utility function to remove any information from ordinar state about deleted outcome
*/
function mutationClearDeletedOrdinarsInfo(ordinarState, deletedOutcomeIds) {
    ordinarState.errorMessages = (0, omit_1.default)(ordinarState.errorMessages, deletedOutcomeIds);
    ordinarState.outcomeErrors = (0, omit_1.default)(ordinarState.outcomeErrors, deletedOutcomeIds);
    ordinarState.outcomesAmounts = (0, omit_1.default)(ordinarState.outcomesAmounts, deletedOutcomeIds);
}
/*
 Utility function to compute and store basket outcomes considering diffs.
 The results are stored in a provided dictionary, keyed by getBasketOutcomeKey func.
 */
const mutationComputeBasketOutcomesMap = ({ outcomesList, outcomesMap, }) => {
    // Set to track all new and updated keys in the outcomesMap
    const newOutcomesKeysSet = new Set();
    outcomesList.forEach((outcome) => {
        const outcomeKey = (0, _1.getBasketOutcomeKey)(outcome);
        // Add the key to the set of new keys
        newOutcomesKeysSet.add(outcomeKey);
        const outcomesMapStoreValue = (0, _1.adjustMaxBet)(outcome);
        // Skip affecting the store if no diff, otherwise update or add the outcome
        if (!(0, isEqual_1.default)(outcomesMap[outcomeKey], outcomesMapStoreValue)) {
            outcomesMap[outcomeKey] = outcomesMapStoreValue;
        }
    });
    // Identify and remove keys from outcomesMap that are not in the newOutcomesKeysSet
    Object.keys(outcomesMap).forEach((existingKey) => {
        if (!newOutcomesKeysSet.has(existingKey)) {
            delete outcomesMap[existingKey];
        }
    });
};
exports.mutationComputeBasketOutcomesMap = mutationComputeBasketOutcomesMap;
/**
 * Removes an outcome from the basket outcomes map by ID.
 * @param outcomeId - The ID of the outcome to remove.
 * @param outcomesMap - The map from which to remove the outcome.
 */
const mutationRemoveBasketOutcomeById = ({ outcomeId, outcomesMap, }) => {
    // Directly iterate over the map's entries to find the outcome by ID
    for (const [outcomeKey, outcome] of Object.entries(outcomesMap)) {
        if (outcome.id === outcomeId) {
            // Once found, delete the outcome from the map using its key and break the loop
            delete outcomesMap[outcomeKey];
            break; // Early exit as we've found and removed the targeted outcome
        }
    }
};
exports.mutationRemoveBasketOutcomeById = mutationRemoveBasketOutcomeById;
//# sourceMappingURL=state.js.map